// extracted by mini-css-extract-plugin
export default {"label":"label__FOoN_","avatar":"avatar__AaavI","badgeButton":"badgeButton__vbXH3"};